export const FETCH_POINTEXCHANGE_REQUEST = "FETCH_POINTEXCHANGE_REQUEST";
export const FETCH_POINTEXCHANGE_SUCCESS = "FETCH_POINTEXCHANGE_SUCCESS";
export const FETCH_POINTEXCHANGE_FAILURE = "FETCH_POINTEXCHANGE_FAILURE"